import NavBar from '@/components/Nav.vue';

export default {
    name: 'AgreementPage',
    components: {
        NavBar,
    },
    data() {
        return {
            type: this.$route.params.type
        }
    }
}